import React from 'react';
import { Home, Compass, Gift, Zap, User } from 'lucide-react';
import { ScreenName } from '../types';
interface BottomNavProps {
  currentScreen: ScreenName;
  onNavigate: (screen: ScreenName) => void;
}
export function BottomNav({
  currentScreen,
  onNavigate
}: BottomNavProps) {
  const tabs = [{
    id: 'home',
    icon: Home,
    label: 'Home'
  }, {
    id: 'explore',
    icon: Compass,
    label: 'Explore'
  }, {
    id: 'gifting',
    icon: Gift,
    label: 'Gifts'
  }, {
    id: 'drops',
    icon: Zap,
    label: 'Drops'
  }, {
    id: 'profile',
    icon: User,
    label: 'Profile'
  }];
  // Determine active tab (handle nested screens)
  const getActiveTab = (screen: ScreenName) => {
    if (screen === 'storeProfile' || screen === 'menu' || screen === 'checkout' || screen === 'checkInSuccess') return 'explore';
    if (screen === 'giftRedeem' || screen === 'giftHistory') return 'gifting';
    if (screen === 'orders' || screen === 'orderDetails') return 'profile';
    return screen;
  };
  const activeTab = getActiveTab(currentScreen);
  return <div className="fixed bottom-0 left-0 right-0 bg-black rounded-t-3xl shadow-lg px-2 py-2 flex justify-around max-w-md mx-auto z-50" data-id="element-28">
      {tabs.map(tab => {
      const Icon = tab.icon;
      const isActive = activeTab === tab.id;
      return <button key={tab.id} onClick={() => onNavigate(tab.id as ScreenName)} className={`flex flex-col items-center justify-center py-2 px-3 rounded-xl transition-all ${isActive ? 'bg-[#FFFC00] text-black' : 'text-white'}`} data-id="element-29">
            <Icon size={20} className={isActive ? 'text-black' : 'text-white'} data-id="element-30" />
            <span className="text-xs mt-1 font-medium" data-id="element-31">{tab.label}</span>
          </button>;
    })}
    </div>;
}